module.exports = __webpack_public_path__ + "img/admin-portal.99e9c7a4.png";